<template>
  <div class="rejected-list">
    <div class="rj-page-card">
      <div class="rj-page-card__title">
        驳回记录
      </div>
      <div class="rj-page-card__content">
        <el-table
          :data="rejectedList"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="approvalUserName"
            label="审批人"
            min-width="180"
            align="left"
          />
          <el-table-column
            prop="approvalContent"
            label="审批意见"
            align="left"
          />
          <el-table-column
            prop="approvalTime"
            label="审批时间"
            align="left"
            min-width="180"
          />
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RejectedList',
  data () {
    return {
      rejectedList: []
    };
  }
};
</script>

<style lang="scss">

</style>
